const hasSlideContent = (images) => {
    if (!images) return false
    return images.some(image => (
        !!(image.titleText && image.titleText.trim()) ||
        !!(image.freetextText && image.freetextText.trim()) ||
        !!(image.ctaText && image.ctaText.trim()) ||
        !!image.movieId ||
        !!image.performanceId ||
        !!image.backdropUrl ||
        !!image.logoOverrideUrl
    ))
}

export default hasSlideContent
